import React, { PureComponent } from 'react';
import Reserve from './reserve';
class ReserveRoutes extends PureComponent {
    render() {
        return <Reserve {...this.props} />;
    }
}

export default ReserveRoutes;
